import script from "./AppTooltip.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppTooltip.vue?vue&type=script&setup=true&lang=ts"

import "./AppTooltip.vue?vue&type=style&index=0&id=16bfbe46&lang=scss"

const __exports__ = script;

export default __exports__